import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { FooterComponent } from './pages/footer/footer.component';
import { HeaderComponent } from './pages/header/header.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DownloadsComponent } from './pages/downloads/downloads.component';
import { FaqComponent } from './pages/faq/faq.component';
import { ExamfeeComponent } from './pages/examfee/examfee.component';
import { InstructionsComponent } from './pages/instructions/instructions.component';
import { MobileappComponent } from './pages/mobileapp/mobileapp.component';
import { AboutcbtComponent } from './pages/aboutcbt/aboutcbt.component';
import { CrsComponent } from './pages/crs/crs.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatTableExporterModule } from 'mat-table-exporter';


// Angular
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { DpDatePickerModule } from "ng2-date-picker";
import { GrsComponent } from './pages/grs/grs.component';
import { PdupComponent } from './pages/pdup/pdup.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AdminComponent } from './pages/admin/admin.component';
import { EriformlistComponent } from './pages/eriformlist/eriformlist.component';
import { EriformEditComponent } from './pages/eriform-edit/eriform-edit.component';
import { LayoutComponent } from './layout/layout.component';
import { EricountComponent } from './pages/ericount/ericount.component';
import { EristatusComponent } from './pages/eristatus/eristatus.component';
import { EriviewComponent } from './pages/eriview/eriview.component';
import { PdulistComponent } from './pages/pdulist/pdulist.component';
import { PdueditComponent } from './pages/pduedit/pduedit.component';
import { PduviewComponent } from './pages/pduview/pduview.component';
import { InvigidashboardComponent } from './pages/invigidashboard/invigidashboard.component';
import { EriformComponent } from './pages/eriform/eriform.component';
import { InvigiericountComponent } from './pages/invigiericount/invigiericount.component';
import { TrackidComponent } from './pages/trackid/trackid.component';
import { PriformComponent } from './pages/priform/priform.component';
import { InvigilatoradminComponent } from './pages/invigilatoradmin/invigilatoradmin.component';
import { InvigilatorviewComponent } from './pages/invigilatorview/invigilatorview.component';
import { CandidateComponent } from './pages/candidate/candidate.component';
import { CandidatedashboardComponent } from './pages/candidatedashboard/candidatedashboard.component';
import { CandidateformComponent } from './pages/candidateform/candidateform.component';
import { CandidateviewComponent } from './pages/candidateview/candidateview.component';
import { CrilistComponent } from './pages/crilist/crilist.component';
import { CrieditComponent } from './pages/criedit/criedit.component';
import { CriviewComponent } from './pages/criview/criview.component';
import { AdminreportComponent } from './pages/adminreport/adminreport.component';
import { ShippedreportsComponent } from './pages/shippedreports/shippedreports.component';
import { ShippedviewComponent } from './pages/shippedview/shippedview.component';
import { ExamcenterlistComponent } from './pages/examcenterlist/examcenterlist.component';
import { DirnimilistComponent } from './pages/dirnimilist/dirnimilist.component';
import { DirnimieditComponent } from './pages/dirnimiedit/dirnimiedit.component';
import { DirnimiviewComponent } from './pages/dirnimiview/dirnimiview.component';
import { ExamComponent } from './pages/exam/exam.component';
import { ExamformComponent } from './pages/examform/examform.component';
import { CbtfeepayComponent } from './pages/cbtfeepay/cbtfeepay.component';
import { ExamformstateComponent } from './pages/examformstate/examformstate.component';
import { ExamfeeitiComponent } from './pages/examfeeiti/examfeeiti.component';
import { ItiloginComponent } from './pages/CTSITI/itilogin/itilogin.component';
import { ItiotpComponent } from './pages/CTSITI/itiotp/itiotp.component';
import { ItibtnComponent } from './pages/CTSITI/itibtn/itibtn.component';
import { ShowtableComponent } from './pages/CTSITI/showtable/showtable.component';
import { PaytableComponent } from './pages/CTSITI/paytable/paytable.component';
import { ViewtableComponent } from './pages/CTSITI/viewtable/viewtable.component';
import { ShowstatetableComponent } from './pages/CTSSTATE/showstatetable/showstatetable.component';
import { ShowpaytableComponent } from './pages/CTSSTATE/showpaytable/showpaytable.component';
import { StateloginComponent } from './pages/CTSSTATE/statelogin/statelogin.component';
import { CtsctudloginComponent } from './pages/CTSSTUD/ctsctudlogin/ctsctudlogin.component';
import { ReexamComponent } from './pages/reexam/reexam/reexam.component';
import { ImportITIComponent } from './pages/import-iti/import-iti.component';
import { OneComponent } from './pages/one/one.component';
import { ItiexamadminComponent } from './pages/itiexamadmin/itiexamadmin.component';
import { CandidatelistComponent } from './pages/candidatelist/candidatelist.component';
import { IticodelistComponent } from './pages/iticodelist/iticodelist.component';
import { PaymentverifiedlistComponent } from './pages/paymentverifiedlist/paymentverifiedlist.component';





@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FooterComponent,
    HeaderComponent,
    DownloadsComponent,
    FaqComponent,
    ExamfeeComponent,
    InstructionsComponent,
    MobileappComponent,
    AboutcbtComponent,
    CrsComponent,
    GrsComponent,
    PdupComponent,
    DashboardComponent,
    AdminComponent,
    EriformlistComponent,
    EriformEditComponent,
    LayoutComponent,
    EricountComponent,
    EristatusComponent,
    EriviewComponent,
    PdulistComponent,
    PdueditComponent,
    PduviewComponent,
    InvigidashboardComponent,
    EriformComponent,
    InvigiericountComponent,
    TrackidComponent,
    PriformComponent,
    InvigilatoradminComponent,
    InvigilatorviewComponent,
    CandidateComponent,
    CandidatedashboardComponent,
    CandidateformComponent,
    CandidateviewComponent,
    CrilistComponent,
    CrieditComponent,
    CriviewComponent,
    AdminreportComponent,
    ShippedreportsComponent,
    ShippedviewComponent,
    ExamcenterlistComponent,
    DirnimilistComponent,
    DirnimieditComponent,
    DirnimiviewComponent,
    ExamComponent,
    ExamformComponent,
    CbtfeepayComponent,
    ExamformstateComponent,
    ExamfeeitiComponent,
    ItiloginComponent,
    ItiotpComponent,
    ItibtnComponent,
    ShowtableComponent,
    PaytableComponent,
    ViewtableComponent,
    ShowstatetableComponent,
    ShowpaytableComponent,
    StateloginComponent,
    CtsctudloginComponent,
    ReexamComponent,
    ImportITIComponent,
    OneComponent,
    ItiexamadminComponent,
    CandidatelistComponent,
    IticodelistComponent,
    PaymentverifiedlistComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DpDatePickerModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatTableExporterModule

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
